import { render, staticRenderFns } from "./Comparison.vue?vue&type=template&id=699ea464&"
import script from "./Comparison.vue?vue&type=script&lang=js&"
export * from "./Comparison.vue?vue&type=script&lang=js&"
import style0 from "./Comparison.vue?vue&type=style&index=0&id=699ea464&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports